var React = require('react');

function NightGolf (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.3125 19.2501C7.90898 19.2501 5.60389 18.2953 3.90434 16.5958C2.2048 14.8962 1.25 12.5911 1.25 10.1876C1.25 6.51572 3.35937 3.22353 6.62539 1.80205C6.7405 1.75188 6.86804 1.73755 6.99141 1.76092C7.11478 1.78429 7.22825 1.84427 7.31704 1.93306C7.40582 2.02184 7.46581 2.13532 7.48918 2.25868C7.51255 2.38205 7.49821 2.5096 7.44805 2.62471C7.07305 3.48564 6.875 4.58838 6.875 5.8126C6.875 10.1204 10.3797 13.6251 14.6875 13.6251C15.9117 13.6251 17.0145 13.427 17.8754 13.052C17.9905 13.0019 18.118 12.9875 18.2414 13.0109C18.3648 13.0343 18.4783 13.0943 18.567 13.1831C18.6558 13.2718 18.7158 13.3853 18.7392 13.5087C18.7625 13.6321 18.7482 13.7596 18.698 13.8747C17.2766 17.1407 13.9844 19.2501 10.3125 19.2501Z","fill":"#616466"}));
}

NightGolf.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = NightGolf;

NightGolf.default = NightGolf;
